import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import $api from "../../shared/api/axios";
import { Label } from "@libs/zapi-ui/shadcn";
import { FigmaTypography } from "@libs/zapi-ui/custom";
import { CriteriaAnswerChangeLogResponseSchema } from "./model/types";
import { LogsRow } from "./ui/LogsRow";

export const LogsPage = () => {
  const [project, setProject] = useState("");

  const { data, isPending, refetch } = useQuery({
    queryKey: ["get-chapter-answer-logs"],
    queryFn: async () => {
      const response = await $api.get("/projects/chapters/criteria-answer/change-log");
      return response?.data?.data ? CriteriaAnswerChangeLogResponseSchema.parse(response?.data?.data) : [];
    }
  });

  const projectsOptions =
    data?.map((project) => ({
      value: project.id + "",
      label: project.name
    })) || [];

  return (
    <div className="container mx-auto py-8">
      <div className="w-full flex justify-between items-center mb-4 pr-6">
        <FigmaTypography component="h1" variant="heading-1">Criteria Answer Logs</FigmaTypography>
      </div>
      <div className="flex flex-col gap-4 max-w-[350px] mb-6">
        <div className="space-y-2">
          <Label htmlFor="project-filter">Filter by Project</Label>
          <select
            id="project-filter"
            value={project}
            onChange={(e) => setProject(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white"
          >
            <option value="">All Projects</option>
            {projectsOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="mt-12 clear-both">
        <p className="text-lg font-semibold mb-4">User changed criteria answer without updating memo content</p>
        {isPending && <p>Loading...</p>}
        {data
          ?.filter((v) => !project || v.id + "" === project)
          .map((project) => (
            <div key={project.id} className="flex flex-col gap-4 border rounded-lg p-4 mb-6">
              <FigmaTypography component="h2" variant="memo-heading-2">Project: {project.name}</FigmaTypography>
              {project.projectChapters.map((chapter) => (
                <div key={chapter.id} className="flex flex-col gap-4">
                  <h3 className="text-lg font-semibold">Chapter: {chapter.projectTemplateChapter?.name}</h3>
                  <div className="overflow-x-auto">
                    <table className="table-auto border-collapse border border-gray-300 w-full">
                      <thead>
                        <tr>
                          <th className="border border-gray-300 px-2 py-1 min-w-[100px]">Created At</th>
                          <th className="border border-gray-300 px-2 py-1 min-w-[100px]">User</th>
                          <th className="border border-gray-300 px-2 py-1 min-w-[100px]">Criterion</th>
                          <th className="border border-gray-300 px-2 py-1 min-w-[100px]">AI Answer</th>
                          <th className="border border-gray-300 px-2 py-1 min-w-[100px]">User Answer</th>
                          <th className="border border-gray-300 px-2 py-1 min-w-[100px]">Memo Content</th>
                          <th className="border border-gray-300 px-2 py-1 min-w-[100px]">State</th>
                          <th className="border border-gray-300 px-2 py-1 min-w-[110px]"></th>
                        </tr>
                      </thead>
                      <tbody>
                        {chapter.ProjectCriterionAnswerLog.map((log) => (
                          <LogsRow key={log.id} log={log} onResolved={refetch} />
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              ))}
            </div>
          ))}
      </div>
    </div>
  );
};
